import { createComponent } from '@carvana/merch-components';

export const GridWrapper = createComponent('div', {
  className: 'grid w-full grid-cols-1 gap-16 m:grid-cols-3 l:grid-cols-4'
});

export const PopularModelsCard = createComponent('div', {
  className:
    'target flex !h-[100px] h-full items-center overflow-hidden rounded-lg border border-grey-2 bg-grey-1 m:relative m:!h-[316px] m:flex-col'
});

export const CardTitle = createComponent('div', {
  className:
    'mr-auto py-16 pl-16 text-blue-7 tl-header-s m:py-32 m:pl-24 m:tl-header-m'
});

export const ImgWrapper = createComponent('div', {
  className:
    'left-[-20%] top-[-10%] h-[192px] w-1/2 overflow-hidden m:absolute m:h-auto m:w-[430px] l:left-[-10%]'
});
